import type { PluginBranding } from '@sportninja/common/features/account/apiAccess'
import type { PluginSpacingChoice } from '../constants/pluginSettings'

/**
 * The Spacing control's choice: Custom for a unit, or while the admin has
 * picked Custom but not typed one yet; otherwise the named step or Default.
 */
export const pluginSpacingChoiceOf = (
  spacing: PluginBranding['spacing'],
  customOpen: boolean
): PluginSpacingChoice =>
  typeof spacing === 'number' || customOpen ? 'custom' : spacing ?? 'default'
